// Solution générique pour afficher correctement tous les sous-menus sur mobile
document.addEventListener('DOMContentLoaded', function() {
  
  // CSS pour l'affichage correct des sous-menus
  const submenuCSS = `
    <style id="submenu-generic-fix">
      @media (max-width: 768px) {
        .menu-drawer__submenu {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background: #FEFFED !important;
          z-index: 10000 !important;
          width: 100% !important;
          height: 100vh !important;
          overflow-y: auto !important;
          transform: translateX(100%);
          transition: transform 0.3s ease;
        }
        
        .menu-drawer__submenu.show {
          transform: translateX(0) !important;
        }
        
        details[open] .menu-drawer__submenu {
          display: block !important;
          opacity: 1 !important;
          visibility: visible !important;
        }
        
        .menu-drawer__close-button {
          display: flex !important;
          align-items: center !important;
          padding: 15px 20px !important;
          background: none !important;
          border: none !important;
          font-size: 16px !important;
          cursor: pointer !important;
          width: 100% !important;
          text-align: left !important;
          border-bottom: 1px solid #eee !important;
        }
        
        .menu-drawer__close-button svg {
          margin-right: 10px !important;
          transform: rotate(180deg) !important;
          flex-shrink: 0 !important;
        }
        
        .menu-drawer__inner-submenu {
          height: 100% !important;
        }
        
        .menu-drawer__navigation-container {
          position: relative !important;
        }
      }
    </style>
  `;
  
  // Injecter le CSS
  document.head.insertAdjacentHTML('beforeend', submenuCSS);
  
  // Fonction pour gérer tous les sous-menus
  function handleAllSubmenus() {
    // Trouver tous les éléments details dans le menu drawer
    const allMenuDetails = document.querySelectorAll('[id^="Details-menu-drawer-menu-item-"]');
    
    allMenuDetails.forEach(function(detailsElement) {
      const summary = detailsElement.querySelector('summary');
      const submenu = detailsElement.querySelector('.menu-drawer__submenu');
      const backButton = submenu?.querySelector('.menu-drawer__close-button');
      
      if (!summary || !submenu) {
        return; // Passer à l'élément suivant si pas de sous-menu
      }
      
      // Gérer le clic sur le summary (élément principal du menu)
      summary.addEventListener('click', function(e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          e.stopPropagation();
          
          // Ouvrir le details
          detailsElement.setAttribute('open', '');
          
          // Afficher le sous-menu avec animation
          setTimeout(() => {
            submenu.classList.add('show');
          }, 50);
        }
      });
      
      // Gérer le bouton retour si il existe
      if (backButton) {
        // Créer un nouveau bouton pour éviter les conflits d'event listeners
        const newBackButton = backButton.cloneNode(true);
        backButton.parentNode.replaceChild(newBackButton, backButton);
        
        newBackButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Animation de fermeture
          submenu.classList.remove('show');
          
          // Fermer le details après l'animation
          setTimeout(() => {
            detailsElement.removeAttribute('open');
          }, 300);
        });
        
        // Gérer aussi le touch
        newBackButton.addEventListener('touchstart', function(e) {
          if (window.innerWidth <= 768) {
            e.preventDefault();
            this.click();
          }
        });
      }
    });
  }
  
  // Observer pour s'assurer que les menus sont toujours fonctionnels après les changements DOM
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    
    mutations.forEach(function(mutation) {
      // Vérifier si le menu drawer a été modifié
      if (mutation.type === 'childList' && mutation.target.classList?.contains('menu-drawer__navigation-container')) {
        shouldReinit = true;
      }
      
      // Vérifier si l'attribut open a changé sur un details
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'open' && 
          mutation.target.id?.startsWith('Details-menu-drawer-menu-item-')) {
        
        const submenu = mutation.target.querySelector('.menu-drawer__submenu');
        if (submenu && window.innerWidth <= 768) {
          if (mutation.target.hasAttribute('open')) {
            // Force l'affichage si le details est ouvert
            submenu.style.display = 'block';
            submenu.style.opacity = '1';
            submenu.style.visibility = 'visible';
            setTimeout(() => submenu.classList.add('show'), 50);
          } else {
            submenu.classList.remove('show');
          }
        }
      }
    });
    
    if (shouldReinit) {
      setTimeout(handleAllSubmenus, 100);
    }
  });
  
  // Observer le menu drawer
  const menuContainer = document.querySelector('.menu-drawer__navigation-container');
  if (menuContainer) {
    observer.observe(menuContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
  }
  
  // Observer aussi tous les details existants
  const allDetailsElements = document.querySelectorAll('[id^="Details-menu-drawer-menu-item-"]');
  allDetailsElements.forEach(function(detailsElement) {
    observer.observe(detailsElement, {
      attributes: true,
      attributeFilter: ['open']
    });
  });
  
  // Gérer le redimensionnement
  window.addEventListener('resize', function() {
    if (window.innerWidth > 768) {
      // Fermer tous les sous-menus ouverts sur desktop
      const allSubmenus = document.querySelectorAll('.menu-drawer__submenu');
      allSubmenus.forEach(function(submenu) {
        submenu.classList.remove('show');
      });
    }
  });
  
  // Initialisation
  handleAllSubmenus();
  
});

// Fonction utilitaire pour debug tous les menus
window.debugAllMenus = function() {
  const allDetails = document.querySelectorAll('[id^="Details-menu-drawer-menu-item-"]');
  console.log('Éléments details trouvés:', allDetails.length);
  
  allDetails.forEach(function(details, index) {
    const submenu = details.querySelector('.menu-drawer__submenu');
    const summary = details.querySelector('summary');
    console.log(`Menu ${index + 1}:`, {
      id: details.id,
      hasSubmenu: !!submenu,
      hasSummary: !!summary,
      summaryText: summary?.textContent?.trim()
    });
  });
};